const whatsappLink = whatsapp => `https://wa.me/${whatsapp.replace(/\D/g, '')}`;

const telegramLink = telegram => `https://t.me/${telegram.replace(/\s/g, '')}`;

const messengerLink = messenger => `https://m.me/${messenger.replace(/\s/g, '')}`;

export { whatsappLink, telegramLink, messengerLink };
